import React, { useState, useEffect } from 'react'
import { WidgetContent, Divider, TextField, Select } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import { ModalButton } from '../UI/ModalButton'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import CloseIcon from '@material-ui/icons/ClearRounded'
import SmConfirmModal from '../UI/SmConfirmModal'
import FormInputGroup from '../UI/FormInputGroup'
import { api } from '../Controllers/api'

const ViewMaterialModal = props => {
  const [unit, setUnit] = useState()
  const [confirmSaveModal, setConfirmSaveModal] = useState(false)
  const [modalFunction, setModalFunction] = useState() //view , edit , new

  const volumeUnits = [
    {
      value: 'kg',
      label: 'kg'
    },
    {
      value: 'm3',
      label: (
        <span>
          m<sup>3</sup>
        </span>
      )
    },
    {
      value: 'yd3',
      label: (
        <span>
          yd<sup>3</sup>
        </span>
      )
    },
    {
      value: 'tonne',
      label: 'tonne'
    }
  ]

  const handleSaveButtonClick = values => {
    if (!values.singleTruck || !values.tandemTruck || !values.triaxleTruck) {
      return
    }

    const unit = values.unit.value
    values.unit = unit
    if (modalFunction === 'new') {
      api
        .post(`materials`, values)
        .then(data => {
          setConfirmSaveModal(true)
        })
        .catch(err => {
          console.log(err)
          alert('Error creating material')
        })
    } else if (modalFunction === 'edit') {
      api
        .put(`materials/${props.selectedMaterial._id}`, values)
        .then(data => {
          props.getMaterials()
          setConfirmSaveModal(true)
        })
        .catch(err => {
          console.log(err)
          alert('Error creating material')
        })
    }
  }

  const handleEdit = () => {
    setConfirmSaveModal(false)
    setModalFunction('view')
  }

  const materialsValue = truckOrTrailerType => {
    return truckOrTrailerType && modalFunction === 'view'
      ? truckOrTrailerType.toFixed(2)
      : truckOrTrailerType
  }

  useEffect(() => {
    if (props.selectedMaterial === 'new') {
      setModalFunction('new')
    } else {
      setUnit(props.selectedMaterial.unit)
      setModalFunction('view')
    }
  }, [props.selectedMaterial])

  return (
    <CreateNewModal
      title={
        props.selectedMaterial === 'new'
          ? 'New Material'
          : modalFunction === 'edit'
          ? 'Edit Material'
          : props.selectedMaterial.materialName
      }
      bannerText={
        modalFunction === 'new' || modalFunction === 'edit'
          ? 'Press Save when finished entering all information.'
          : 'Press Edit to update material name, volume or unit of measurement'
      }
      handleCloseModal={props.handleViewMaterialModal}
    >
      <Formik
        initialValues={
          typeof props.selectedMaterial === 'object'
            ? {
                materialName: props.selectedMaterial.materialName,
                unit: volumeUnits.find(unit => unit.value === props.selectedMaterial.unit),
                singleTruck: props.selectedMaterial.singleTruck,
                tandemTruck: props.selectedMaterial.tandemTruck,
                triaxleTruck: props.selectedMaterial.triaxleTruck,
                endDumpTruck: props.selectedMaterial.endDumpTruck,
                tandemPonyTrailer: props.selectedMaterial.tandemPonyTrailer,
                triPonyTrailer: props.selectedMaterial.triPonyTrailer,
                threeAxleTransferTrailer: props.selectedMaterial.threeAxleTransferTrailer,
                fourAxleTransferTrailer: props.selectedMaterial.fourAxleTransferTrailer,
                quadTrailer: props.selectedMaterial.quadTrailer
              }
            : {
                materialName: '',
                unit: { value: ' ', label: ' ' },
                singleTruck: '',
                tandemTruck: '',
                triaxleTruck: '',
                endDumpTruck: '',
                tandemPonyTrailer: '',
                triPonyTrailer: '',
                threeAxleTransferTrailer: '',
                fourAxleTransferTrailer: '',
                quadTrailer: ''
              }
        }
        validationSchema={NewMaterialSchema}
        handleSubmit={e => console.log('')}
        onSubmit={values => {
          handleSaveButtonClick(values)
        }}
        render={({
          values,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          setFieldTouched
        }) => (
          <form onSubmit={handleSubmit}>
            <WidgetContent
              style={{
                height: '355px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: 0,
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
            >
              <div style={{ paddingTop: '20px', width: '100%', padding: '0 30px' }}>
                <div style={{ padding: '0 30px' }}>
                  <div>
                    <p style={{ fontSize: '18px', color: '#3E3F42', padding: '25px 0px' }}>
                      General
                    </p>
                  </div>
                  <FormInputGroup direction="horizontal">
                    <div style={{ marginTop: '4px' }}>
                      <TextField
                        label="Material Name"
                        name="materialName"
                        className={
                          errors.materialName
                            ? 'threeQuarterWidthInputBox inputBoxError'
                            : 'threeQuarterWidthInputBox'
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.materialName}
                        disabled={modalFunction === 'view'}
                      />
                      <ErrorMessage
                        name="materialName"
                        render={msg => (
                          <span
                            style={{
                              position: 'relative',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                    <div>
                      {modalFunction === 'view' ? (
                        <TextField
                          label="unit"
                          name="unit"
                          className="unitInputBoxDisabled"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.unit.value}
                          disabled={true}
                        />
                      ) : (
                        <>
                          <Select
                            className="unitSelect"
                            activeOption={values.unit}
                            label="unit"
                            name="unit"
                            options={volumeUnits}
                            position="bottomRight"
                            onOptionClick={e => setFieldValue('unit', e)}
                            onBlur={() => setFieldTouched('unit')}
                          />
                          <ErrorMessage
                            name="unit"
                            render={msg => (
                              <span
                                style={{
                                  position: 'relative',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg.value}
                              </span>
                            )}
                          />
                        </>
                      )}
                    </div>
                  </FormInputGroup>
                </div>

                <Divider style={{ marginTop: '30px', marginBottom: '4px' }} />

                <div style={{ padding: '0 30px' }}>
                  <div>
                    <p style={{ fontSize: '18px', color: '#3E3F42', padding: '25px 0px' }}>
                      Trucks
                    </p>
                  </div>
                  <FormInputGroup direction="horizontal">
                    <TextField
                      label="Single"
                      name="singleTruck"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.singleTruck)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="singleTruck"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />

                    <TextField
                      label="Tandem"
                      name="tandemTruck"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.tandemTruck)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="tandemTruck"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                    <TextField
                      label="Tri-axle"
                      name="triaxleTruck"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.triaxleTruck)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    {/* <ErrorMessage
                      name="triaxleTruck"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    /> */}
                  </FormInputGroup>
                  <div style={{ marginTop: '16px' }}>
                    <FormInputGroup direction="horizontal">
                      <TextField
                        label="End Dump"
                        name="endDumpTruck"
                        className={`quarterWidthInputBox ${
                          modalFunction === 'new' ? '' : 'with-icon'
                        }`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={materialsValue(values.endDumpTruck)}
                        rightEl={unit}
                        type="number"
                        disabled={modalFunction === 'view'}
                      />
                      <ErrorMessage
                        name="endDumpTruck"
                        render={msg => (
                          <span
                            style={{
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </FormInputGroup>
                  </div>
                </div>

                <Divider style={{ marginTop: '30px', marginBottom: '4px' }} />

                <div style={{ padding: '0 30px' }}>
                  <div>
                    <p style={{ fontSize: '18px', color: '#3E3F42', padding: '25px 0px' }}>
                      Trailers
                    </p>
                  </div>
                  <FormInputGroup direction="horizontal">
                    <TextField
                      label="Tandem Pony"
                      name="tandemPonyTrailer"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.tandemPonyTrailer)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="tandemPonyTrailer"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />

                    <TextField
                      label="Tri Pony"
                      name="triPonyTrailer"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.triPonyTrailer)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="triPonyTrailer"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                    <TextField
                      label="3 Axle transfer"
                      name="threeAxleTransferTrailer"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.threeAxleTransferTrailer)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="threeAxleTransferTrailer"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </FormInputGroup>
                  <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '16px 0' }}>
                    <TextField
                      label="4 Axle transfer"
                      name="fourAxleTransferTrailer"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.fourAxleTransferTrailer)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                      wrapperProps={{ style: { marginRight: '30px' } }}
                    />
                    <ErrorMessage
                      name="fourAxleTransferTrailer"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                    <TextField
                      label="Quad Trailer"
                      name="quadTrailer"
                      className={`quarterWidthInputBox ${
                        modalFunction === 'new' ? '' : 'with-icon'
                      }`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={materialsValue(values.quadTrailer)}
                      rightEl={unit}
                      type="number"
                      disabled={modalFunction === 'view'}
                    />
                    <ErrorMessage
                      name="quadTrailer"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </div>
              </div>
            </WidgetContent>

            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              {modalFunction === 'view' ? (
                <>
                  <div style={{ width: '83px' }}>
                    <ModalButton
                      buttonStyle="tertiary"
                      name="Edit"
                      onClick={() => setModalFunction('edit')}
                    />
                  </div>
                  <div style={{ width: '83px' }}>
                    <ModalButton success onClick={props.handleViewMaterialModal} name="OK" />
                  </div>
                </>
              ) : (
                <>
                  <div style={{ width: '83px' }}>
                    <ModalButton
                      buttonStyle="tertiary"
                      name="Cancel"
                      onClick={
                        modalFunction === 'edit'
                          ? () => setModalFunction('view')
                          : props.handleViewMaterialModal
                      }
                    />
                  </div>
                  <div style={{ width: '83px' }}>
                    <ModalButton
                      buttonStyle={values.materialName ? 'primary' : 'tertiary'}
                      type="submit"
                      success={values.materialName !== ''}
                      name="Save"
                    />
                  </div>
                </>
              )}
            </WidgetContent>
          </form>
        )}
      />
      {confirmSaveModal && (
        <SmConfirmModal
          heading={modalFunction === 'edit' ? 'Material Updated!' : 'New Material Saved!'}
          text={
            modalFunction === 'edit'
              ? `${props.selectedMaterial.materialName} material has been updated.`
              : 'You may now use this material when crerating a new haul'
          }
          onCloseClick={props.handleViewMaterialModal}
          onOKClick={modalFunction === 'edit' ? handleEdit : props.handleViewMaterialModal}
          confirmButtonType="primary"
        />
      )}
    </CreateNewModal>
  )
}

export default ViewMaterialModal

const NewMaterialSchema = Yup.object().shape({
  materialName: Yup.string()
    .min(1, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  unit: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  singleTruck: Yup.number().min(0, 'Invalid'),
  tandemTruck: Yup.number().min(0, 'Invalid'),
  triaxleTruck: Yup.number()
    .min(0, 'Invalid')
    .required('Required'),
  endDumpTruck: Yup.number().min(0, 'Invalid'),
  tandemPonyTrailer: Yup.number().min(0, 'Invalid'),
  threeAxleTransferTrailer: Yup.number().min(0, 'Invalid'),
  fourAxleTransferTrailer: Yup.number().min(0, 'Invalid'),
  quadTrailer: Yup.number().min(0, 'Invalid')
})
